import { apiSlice } from "./apiSlice";

export const hseDashboardSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => {
        return {
            getHSEKpis: builder.query({
                query: ({ projectId, ...params }) => ({
                    url: `/HSEData/kpis/${projectId}`,
                    params
                })
            }),

            getHSEAgeing: builder.query({
                query: ({ projectId }) => ({
                    url: `/HSEData/ageings/${projectId}`
                })
            }),
            getHSEStatistics: builder.query({
                query: (params) => ({
                    url: `/HSEData/statistics`,
                    params
                })
            }),
            getHSEDashBoard: builder.query({
                query: (params) => ({
                    url: `/HSEData/dashboard-graphs/${params.projectId}`,
                    // params
                })
            })
        }
    }
})


export const {
    useGetHSEKpisQuery,
    useGetHSEAgeingQuery,
    useLazyGetHSEKpisQuery,
    useGetHSEStatisticsQuery,
    useGetHSEDashBoardQuery
} = hseDashboardSlice